export const defaultList = {
  status: "loading",
  items: []
}

export const defaultPromo = {
  code: '',
  discount: 0
}

export const defaultTax = {
  name: "",
  rate: 0
}

export const defaultCurrency = {
  name: "US Daller",
  iso: "USD"
}

// export const defaultRoles = {
//   name: "Roles",
//   value: [
//     { name: "Admin", value: "admin" }
//   ]
// }

export const defaultRoles = [
  { name: "Agent", value: "agent" },
  // { name: "Admin", value: "admin" }
]

export const orderStatus = [
  {
    value: "Pending",
    label: "Pending payment"
  },
  {
    value: "Payment Success",
    label: "Payment Success"
  },
  {
    value: "Processing",
    label: "Processing"
  },
  // {
  //   value: "On hold",
  //   label: "On hold"
  // },
  {
    value: "Completed",
    label: "Completed"
  },
  {
    value: "Cancelled",
    label: "Cancelled"
  },
  // {
  //   value: "Refunded",
  //   label: "Refunded"
  // },
  {
    value: "Failed",
    label: "Failed"
  },
  // {
  //   value: "Draft",
  //   label: "Draft"
  // },
]
